import * as customerAction from './actions'
import {Map, fromJS} from 'immutable';


let itemInitState = Map({
      'info': Map({
          'fetching': false,
          'fetched': false,
          'payload': Map()
      }),
      'tickets': Map({
          'fetching': false,
          'fetched': false,
          'payload': Map()
      }),
      'stats': Map({
          'fetching': false,
          'fetched': '',
          'payload': Map(),

      })
    });

function customerItemReducer(state, action) {
    switch(action.type) {
        case customerAction.READ_TICKETS_FROM_DB_REQUEST:
            return state.setIn(['tickets', 'fetching'], true);
        case customerAction.READ_TICKETS_FROM_DB_SUCCESS:
            return state.setIn(['tickets', 'payload'], fromJS(action.tickets))
                    .setIn(['tickets', 'fetching'], false)
                    .setIn(['tickets', 'fetched'], new Date().toLocaleString());

        case customerAction.SET_INFO:
        case customerAction.UPDATE_TO_DB_SUCCESS:
            return state.setIn(['info', 'payload'], fromJS(action.info))
                    .setIn(['info', 'payload', 'is_online'], fromJS(action.info.is_online))
        case customerAction.UPDATE_INFO:
            return state.setIn(['info', 'payload', action.key], fromJS(action.value))


      case customerAction.IS_ONLINE:
           return state.setIn(['info','payload','is_online'], true)
      case customerAction.IS_OFFLINE:
           return state.setIn(['info', 'payload','is_online'], false)

      // =============  STATISTICS OF CUSTOMER ============
      case customerAction.READ_STATS_FROM_DB_REQUEST:
          return state.setIn(['stats', 'fetching'], true);
      case customerAction.READ_STATS_FROM_DB_SUCCESS:
          return state
            .setIn(['stats', 'payload'], fromJS(action.stats))
            .setIn(['stats', 'fetching'], false)
            .setIn(['stats', 'fetched'], new Date().toLocaleString());
      case customerAction.READ_STATS_FROM_DB_FAILURE:
          return state.setIn(['stats', 'fetching'], false);
     // =============  END OF STATISTIC OF CUSTOMER ===========

      case customerAction.CREATE_TAG_SUCCESS:
      case customerAction.DELETE_TAG_SUCCESS:
          return state.setIn(['info', 'payload', 'tags'], fromJS(action.tags))
      default:
          return state;

    }
}

let initState = Map({
    items: Map()
})
function reducer(state= initState, action) {
    switch (action.type) {
        // TAGS
      case customerAction.CREATE_TAG_SUCCESS:
      case customerAction.DELETE_TAG_SUCCESS:
        // ========= TICKETS ===========
      case customerAction.READ_TICKETS_FROM_DB_REQUEST:
      case customerAction.READ_TICKETS_FROM_DB_SUCCESS:
        // ========== STATS  ===========
      case customerAction.READ_STATS_FROM_DB_REQUEST:
      case customerAction.READ_STATS_FROM_DB_SUCCESS:
      case customerAction.READ_STATS_FROM_DB_FAILURE:
      // ========== INFO =============
      case customerAction.SET_INFO:
      case customerAction.UPDATE_TO_DB_SUCCESS:
      // eslint-disable-next-line
      case customerAction.CREATE_TAG_SUCCESS:
      // eslint-disable-next-line
      case customerAction.DELETE_TAG_SUCCESS:
      // ========== ONLINE =============
      case customerAction.IS_ONLINE:
      case customerAction.IS_OFFLINE:
      // ======= update info ======
      case customerAction.UPDATE_INFO:
            var itemPrevState = state.getIn(['items', String(action.id)], itemInitState)
            var itemNextState = customerItemReducer(itemPrevState, action)
            return state.setIn(['items', String(action.id)], itemNextState);
      default:
            return state;
      }
}


export default reducer



// WEBPACK FOOTER //
// ./src/model/Customer/reducer.js